<div *ngIf="loading$ | async" class="spinner-container">
  <div class="spinner"></div>
</div> 